'use client'

import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'shared/api'

import { getDiscountCodes } from '../api'

export default function useQueryDiscountCodes(token: string) {
  return useQuery({
    queryKey: [QueryKey.rebateCodes, token],
    queryFn: async () => {
      const response = await getDiscountCodes({ token })

      return response.data.data
    },
    staleTime: 60000,
    enabled: !!token
  })
}
